'use strict';
define(['app'], function (app) {
    function SegmentedControlController($element, $scope, $timeout, $window) {
        var ctrl = this;
        var measureTimer;
        var measuredIndex = null;
        var measureAttempts = 0;

        ctrl.indicatorStyle = {};
        ctrl.indicatorReady = false;

        ctrl.$onInit = function () {
            $scope.$watch(function () { return ctrl.value; }, function () {
                measuredIndex = null;
                measureAttempts = 0;
                scheduleMeasure();
            });
            $scope.$watchCollection(function () { return ctrl.options; }, function () {
                measuredIndex = null;
                measureAttempts = 0;
                scheduleMeasure();
            });
        };

        ctrl.$postLink = function () {
            scheduleMeasure();
            $window.addEventListener('resize', scheduleMeasure);
        };

        ctrl.$onChanges = function (changes) {
            if (changes.value || changes.options) {
                measuredIndex = null;
                measureAttempts = 0;
                scheduleMeasure();
            }
        };

        ctrl.$doCheck = function () {
            var index = ctrl.selectedIndex();
            if ((index !== measuredIndex || !ctrl.indicatorStyle.width) && !measureTimer) {
                measuredIndex = index;
                scheduleMeasure();
            }
        };

        ctrl.$onDestroy = function () {
            $window.removeEventListener('resize', scheduleMeasure);
            if (measureTimer) {
                $timeout.cancel(measureTimer);
            }
        };

        ctrl.select = function (option) {
            if (!ctrl.disabled && !option.disabled && option.value !== ctrl.value) {
                ctrl.onChange({value: option.value});
                measuredIndex = null;
                scheduleMeasure();
            }
        };

        ctrl.showCount = function (option) {
            var count = Number(option && option.count);
            return option && option.count !== undefined && option.count !== null &&
                option.count !== '' && !isNaN(count) && count > 0;
        };

        ctrl.selectedIndex = function () {
            var options = ctrl.options || [];
            for (var i = 0; i < options.length; i++) {
                if (options[i].value === ctrl.value) {
                    return i;
                }
            }
            return 0;
        };

        ctrl.getIndicatorStyle = function () {
            var host = $element[0].querySelector('.st-segmented');
            var options = host && host.querySelectorAll('.st-segmented__option');
            var active = options && options[ctrl.selectedIndex()];
            if (!active || !active.offsetWidth || !active.offsetHeight) {
                return ctrl.indicatorStyle;
            }
            var style = {
                left: active.offsetLeft + 'px',
                top: active.offsetTop + 'px',
                width: active.offsetWidth + 'px',
                height: active.offsetHeight + 'px'
            };
            if (style.left !== ctrl.indicatorStyle.left || style.top !== ctrl.indicatorStyle.top ||
                style.width !== ctrl.indicatorStyle.width || style.height !== ctrl.indicatorStyle.height) {
                ctrl.indicatorStyle = style;
            }
            ctrl.indicatorReady = true;
            return ctrl.indicatorStyle;
        };

        function scheduleMeasure() {
            if (measureTimer) {
                $timeout.cancel(measureTimer);
            }
            measureTimer = $timeout(measureIndicator, 0, false);
        }

        function measureIndicator() {
            var host = $element[0].querySelector('.st-segmented');
            var options = host && host.querySelectorAll('.st-segmented__option');
            var active = options && options[ctrl.selectedIndex()];
            measureTimer = null;
            if (!active || !active.offsetWidth || !active.offsetHeight) {
                ctrl.indicatorReady = false;
                if (measureAttempts < 20) {
                    measureAttempts += 1;
                    measureTimer = $timeout(measureIndicator, 50, false);
                }
                return;
            }
            measureAttempts = 0;
            ctrl.indicatorStyle = {
                left: active.offsetLeft + 'px',
                top: active.offsetTop + 'px',
                width: active.offsetWidth + 'px',
                height: active.offsetHeight + 'px'
            };
            ctrl.indicatorReady = true;
        }
    }

    SegmentedControlController.$inject = ['$element', '$scope', '$timeout', '$window'];

    app.component('stSegmentedControl', {
        templateUrl: 'app/components/st-segmented-control/st-segmented-control.html',
        bindings: {
            options: '<',
            value: '<',
            label: '@',
            disabled: '<?',
            onChange: '&'
        },
        controller: SegmentedControlController
    });
});
